export const mockupUrl =
  "https://cdn.magicpatterns.com/uploads/3141wNuGcc9Hih86YDj9Vt/packduclesaludablemoc.png";

export const desserts = {
  berryBar: "https://cdn.magicpatterns.com/uploads/uXoK8yeDp8jgG2XkwQR5zx/PHOTO-2026-10-13-20-11-36.jpg",
  pistachioBars: "https://cdn.magicpatterns.com/uploads/bA7sUfFeVVG1dBEXJhn7W1/PHOTO-2026-10-13-20-14-44_2.jpg",
  mintCookies: "https://cdn.magicpatterns.com/uploads/oixQF4UtQQQRbYp8sSqaBk/PHOTO-2026-10-13-20-14-44_3.jpg",
  chocolateCake: "https://cdn.magicpatterns.com/uploads/jaGMbQMiVSYbHVT1aNnA3f/PHOTO-2026-10-13-20-14-44_4.jpg",
  cookieBite: "https://cdn.magicpatterns.com/uploads/hakZwSJoAssSWQrCWDjNdn/PHOTO-2026-10-13-20-14-44_5.jpg",
  popsicles: "https://cdn.magicpatterns.com/uploads/sAjUJDVF1xZFNjTcBvN3z3/PHOTO-2026-10-13-20-14-44_6.jpg",
  roseCupcakes: "https://cdn.magicpatterns.com/uploads/2dQVFUFTm72B84pCYjgLSe/PHOTO-2026-10-13-20-14-44_7.jpg",
  lemonMuffins: "https://cdn.magicpatterns.com/uploads/ntxBsrKEbTgszMbvsxM3Vy/PHOTO-2026-10-13-20-14-44_8.jpg",
  raspberryCake: "https://cdn.magicpatterns.com/uploads/ijBxcTDfp6DREbe3k5dXwu/PHOTO-2026-10-13-20-14-44_9.jpg",
  starCookies: "https://cdn.magicpatterns.com/uploads/cBXdh9m5TA3CtcTphCbFkq/PHOTO-2026-10-13-20-14-44_10.jpg",
  carrotCake: "https://cdn.magicpatterns.com/uploads/2yVnknNdaeTBHtxpXU11bE/PHOTO-2026-10-13-20-14-44_11.jpg",
  blueberryCheesecakes: "https://cdn.magicpatterns.com/uploads/6b4C829nbK45CU29AGr7mH/PHOTO-2026-10-13-20-14-44_12.jpg",
  raspberryCrepes: "https://cdn.magicpatterns.com/uploads/n9wT3s1UvFpw6zrKXRU6EU/PHOTO-2026-10-13-20-14-44_13.jpg",
  swirlBars: "https://cdn.magicpatterns.com/uploads/jmxp1PLLPDJADtx7WUa2WX/PHOTO-2026-10-13-20-14-44_14.jpg",
  hazelnutCups: "https://cdn.magicpatterns.com/uploads/5Qd8LNgiz7BuM96gc4BL5o/PHOTO-2026-10-13-20-14-44_15.jpg",
  homemadeOreos: "https://cdn.magicpatterns.com/uploads/vHvaqdvsz84NxcWmbwwpoB/PHOTO-2026-10-13-20-14-44_16.jpg",
  chocolateDonut: "https://cdn.magicpatterns.com/uploads/5poqgVX8HniCaNy2YXvZsQ/PHOTO-2026-10-13-20-14-44.jpg",
};

export const people = {
  lucia: "https://cdn.magicpatterns.com/patterns/generated-images/c2a4dab5-582c-4035-bd14-f8f5d8cbb76e.jpg",
  marta: "https://cdn.magicpatterns.com/patterns/generated-images/29803731-afdd-488b-be24-25ad21d4a9e3.jpg",
  elena: "https://cdn.magicpatterns.com/patterns/generated-images/864b7f85-d80b-4f0d-9117-9995e9a42673.jpg",
  patricia: "https://cdn.magicpatterns.com/patterns/generated-images/25278833-1e3f-415c-8366-136ffb02e8cd.jpg",
  valentina: "https://cdn.magicpatterns.com/patterns/generated-images/83673a75-d7a8-45f3-8ce0-412072545d52.jpg",
  rosa: "https://cdn.magicpatterns.com/patterns/generated-images/14bcdeb2-5b32-4bc7-be27-11fab54a28a3.jpg",
  camila: "https://cdn.magicpatterns.com/patterns/generated-images/dcf41791-6320-45de-b950-1df4281f201e.jpg",
};

export const lifestyle = {
  kitchen: "https://cdn.magicpatterns.com/patterns/generated-images/368d80a4-ca5d-4355-b975-c2f5ec5bebe0.jpg",
  kids: "https://cdn.magicpatterns.com/patterns/generated-images/fbff3cb4-cc15-45ee-9a59-afc19fd0866f.jpg",
  author: "https://cdn.magicpatterns.com/patterns/generated-images/c974f2b6-6bb0-49dd-a6ab-46e7832acc9e.jpg",
  pantry: "https://cdn.magicpatterns.com/patterns/generated-images/1e697220-0ef8-45ee-9ec2-a7843d032868.jpg",
  goldCard: "https://cdn.magicpatterns.com/patterns/generated-images/5d5b4bb2-9b5d-4b26-8fb7-0a14ffb1423a.jpg",
};

export const marqueeDesserts = [
  { src: desserts.swirlBars, name: "Cheesecake de frutos rojos" },
  { src: desserts.chocolateDonut, name: "Donas de cacao" },
  { src: desserts.roseCupcakes, name: "Cupcakes de vainilla" },
  { src: desserts.pistachioBars, name: "Barritas de pistacho" },
  { src: desserts.homemadeOreos, name: "Galletas tipo Oreo" },
  { src: desserts.blueberryCheesecakes, name: "Mini tartas de arándano" },
  { src: desserts.lemonMuffins, name: "Muffins de limón" },
  { src: desserts.popsicles, name: "Paletas de cacao y menta" },
  { src: desserts.raspberryCrepes, name: "Crepes de frambuesa" },
  { src: desserts.carrotCake, name: "Torta de zanahoria" },
  { src: desserts.hazelnutCups, name: "Mousse de avellana" },
  { src: desserts.starCookies, name: "Cookies rellenas" },
];
